import 'css-chunksrc/feature/check-discount/CheckDiscountModal.module.scss';export default {
  "autoDiscount": "CheckDiscountModal_autoDiscount",
  "manualDiscount": "CheckDiscountModal_manualDiscount",
  "grid": "CheckDiscountModal_grid",
  "divider": "CheckDiscountModal_divider",
  "cta": "CheckDiscountModal_cta"
};